import { useRef } from "react";
import { Nav } from "react-bootstrap";
import {
  FaCreditCard,
  FaFolderOpen,
  FaMailBulk,
  FaMoneyCheck,
  FaTachometerAlt,
  FaUsers,
} from "react-icons/fa";
import { MdAdminPanelSettings } from "react-icons/md";
import { useLocation, useNavigate } from "react-router-dom";

const MASidebar = () => {
  const scrollContainerRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const navLinks = [
    {
      to: "/master-admin-dashboard",
      label: "Dashboard",
      icon: <FaTachometerAlt size={30} />,
    },
    {
      to: "/master-admin-dashboard/user-management",
      label: "User Management",
      icon: <FaUsers size={30} />,
    },
    {
      to: "/master-admin-dashboard/franchises",
      label: "Franchises",
      icon: <MdAdminPanelSettings size={30} />,
    },
    {
      to: "/master-admin-dashboard/credit-management",
      label: "Credit Management",
      icon: <FaCreditCard size={30} />,
    },
        {
      to: "/master-admin-dashboard/frymes-management",
      label: "Frymes Management",
      icon: <FaMoneyCheck size={30} />,
    },
    {
      to: "/master-admin-dashboard/contact-messages",
      label: "Contact Messages",
      icon: <FaMailBulk size={30} />,
    },
    {
      to: "/master-admin-dashboard/settings",
      label: "Settings",
      icon: <FaFolderOpen size={30} />,
    },
  ];

  const isLinkActive = (link) => {
    const currentPath = location.pathname;
    const linkPathname = link.to.split("?")[0];

    if (linkPathname === "/master-admin-dashboard") {
      return currentPath === linkPathname;
    }

    return (
      currentPath === linkPathname || currentPath.startsWith(linkPathname + "/")
    );
  };

  const handleLinkClick = (to) => {
    navigate(to);
  };
  const renderNavLinks = () => (
    <Nav className="flex-column full-height align-items-center">
      {navLinks.map((link, index) => (
        <div
          key={index}
          style={{ position: "relative", width: "100%", marginBottom: "20px" }}
        >
          <div
            onClick={() => handleLinkClick(link.to)}
            className={`nav-link d-flex flex-column align-items-center ${
              isLinkActive(link) ? "active" : ""
            }`}
            style={{
              fontSize: "1.1rem",
              color: isLinkActive(link) ? "#663399" : "#332e38",
              textAlign: "center",
              padding: "10px",
              transition: "color 0.3s",
              cursor: "pointer",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                position: "relative",
                height: "50px",
                minWidth: "100px",
                justifyContent: "center",
              }}
            >
              {link.icon && (
                <span style={{ marginBottom: "10px" }}>{link.icon}</span>
              )}
              {link.label}
            </div>

            {/* Triangle indicator for active link */}
            <div
              className="triangle"
              style={{
                width: "0",
                height: "0",
                borderStyle: "solid",
                borderWidth: "0 0 30px 30px",
                borderColor: "transparent transparent #663399 transparent",
                position: "absolute",
                top: "70%",
                left: "100%",
                marginLeft: "10px",
                display: isLinkActive(link) ? "block" : "none",
              }}
            />
          </div>
          <hr
            style={{ width: "100%", borderColor: "black", margin: "5px 0" }}
          />
        </div>
      ))}
    </Nav>
  );
  return (
    <div
      ref={scrollContainerRef}
      className="sidebar"
      style={{
        width: "220px",
        backgroundColor: "#f8f9fa",
        height: "100vh",
        paddingTop: "30px",
      }}
    >
      {renderNavLinks()}
    </div>
  );
};
export default MASidebar;
